import React, { useState, useEffect } from "react";
import { Modal, ModalBody } from "reactstrap";
import Calendar from "react-calendar";
import {
  getAvailableTimeSlots,
  getAvailableDates,
} from "../../../../actions/bookingAction";
import { connect } from "react-redux";
import { getAdminBusinessId, getLoggedInUserId } from "../../../../utils/authHelper";
import {
  notification,
  getDBFormatedDate,
  getLoggedInUserTimezone,
  computeBookingEndSlot,
} from "../../../../utils/utility";
import Loader from "../../../../components/Loader/Loader";
import { rescheduleEvent } from "../../../../actions/admin/scheduled-event-actions";
import moment from "moment";
import isEmpty from "../../../../validation/is-empty";
import "./scheduledEvents.scss";

const getRescheduleTimezone = (data) => {
  if (data && !isEmpty(data.invitee_timezone)) {
    return data.invitee_timezone;
  }
  return getLoggedInUserTimezone();
};

const UpcomingRescheduleModal = (props) => {
  const [calendarDate, setCalendarDate] = useState(new Date());
  const [selectedSlot, setSelectedSlot] = useState(null);
  const [slots, setSlots] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [availableDates, setAvailableDates] = useState([]);

  const [bookingDate, setBookingDate] = useState(null);

  const timezone = getRescheduleTimezone(props.data);

  useEffect(() => {
    getMonthAvailableDates(moment().month() + 1, moment().year());
  }, []);

  const getMonthAvailableDates = (month, year) => {
      const { getAvailableDates } = props;

      setIsLoading(true);
      let daysInMonth = moment(year + "-" + month, "YYYY-M").daysInMonth();
      let monthDates = [];

      const monthStartDate = getDBFormatedDate(new Date(year, month - 1, 1));
      const monthEndDate = getDBFormatedDate(
        new Date(year, month - 1, daysInMonth)
      );

      while (daysInMonth) {
        monthDates.push(
          getDBFormatedDate(new Date(year, month - 1, daysInMonth))
        );
        daysInMonth--;
      }

      getAvailableDates({
        data: {
          dates: monthDates.reverse(),
          event_id: props.data.event_id,
          timezone,
          business_id: getAdminBusinessId(),
          month_start_date: monthStartDate, 
          month_end_date: monthEndDate,
          staff_id : (props.data.staff_assignment_type == '2' && !isEmpty(props.data.staff_id)) ? props.data.staff_id : null,
        },
        onSuccess: function (result) {
          const { data } = result.data;
          setAvailableDates(data);
          setIsLoading(false);
        },
        onError: function (error) {
          setIsLoading(false);
        },
      });
    };

  /**
   * on calendar date change handler
   * @param {*} date
   */
  const onCalendarDateChange = (date) => {
    const { getAvailableTimeSlots } = props;
    setCalendarDate(date);
    setBookingDate(getDBFormatedDate(date));
    setIsLoading(true);
    getAvailableTimeSlots({
      data: {
        selected_date: getDBFormatedDate(date),
        staff_id: (props.data.staff_assignment_type == '2' && !isEmpty(props.data.staff_id)) ? props.data.staff_id : null,
        business_id: getAdminBusinessId(),
        event_id: props.data.event_id,
        timezone,
      },
      onSuccess: function (response) {
        console.log("response", response);
        setIsLoading(false);
        setSlots(response);
      },
      onError: (error) => {
        setIsLoading(false);
        if (error?.response?.data?.message) {
          notification.error(error.response.data.message);
        } else {
          notification.error("Could not load time slots. Please try again.");
        }
      },
    });
  };

  /**
   * on select time slot
   * @param {*} timeslot
   */
  const onSelectTimeSlot = (timeslot) => {
    setSelectedSlot(timeslot);
  };

  /**
   * on confirm reschedule
   */
  const onConfirm = () => {
    const {
      data,
      rescheduleEvent,
      handleClose,
      handleViewDetailClose,
      loadUpcomingEvents,
    } = props;
    const bookingDateTime = bookingDate + " " + selectedSlot;
    const endSlot = computeBookingEndSlot(
      bookingDate,
      selectedSlot,
      data.timeslot,
      timezone
    );

    setIsLoading(true);
    rescheduleEvent({
      data: {
        booking_id: data.id,
        booking_date_time: bookingDateTime,
        start_time: selectedSlot + ":00",
        end_time: endSlot + ":00",
        reschedule_reason: "",
        timezone,
      },
      onSuccess: function (response) {
        console.log(response);
        setIsLoading(false);
        notification.success("Reschedule Successfully..");
        handleClose();
        handleViewDetailClose();
        loadUpcomingEvents();
      },
      onError: function (error) {
        setIsLoading(false);
        if (!isEmpty(error?.response?.data?.message)) {
          notification.error(error.response.data.message);
        } else {
          notification.error("An error occurred. Please try again.");
        }
      },
    });
  };

  return (
    <>
      <Modal
        returnFocusAfterClose={true}
        isOpen={props.showRescheduleModal}
        toggle={props.handleClose}
        centered
        className="se-details-modal se-reschedule-modal"
        contentClassName="se-details-modal__content"
      >
        <ModalBody>
          <div className="se-details">
            <header className="se-details__header">
              <div className="se-details__header-copy">
                <p className="se-details__eyebrow">Reschedule</p>
                <h2>{props.data?.event_name || "Pick a new time"}</h2>
              </div>
              <button
                type="button"
                className="se-details__close"
                onClick={props.handleClose}
                aria-label="Close"
              >
                ×
              </button>
            </header>

              <div className="row sub_div">
                <div className="col-sm-6 col-lg-6 col-md-6 mb-5 mb-md-0">
                  <input
                    type="text"
                    className="form-control rs-select-date-input"
                    id="result"
                    placeholder="Select date"
                    disabled="disabled"
                  />
                  <form className="row">
                    <div className="col-md-12">
                      <Calendar
                        tileClassName={({ date }) => {
                          const calendarDate = getDBFormatedDate(date);

                          if (
                            availableDates.find(
                              (availableDate) => availableDate === calendarDate
                            )
                          ) {
                            return "highlight";
                          }
                        }}
                        onActiveStartDateChange={({ activeStartDate }) => {
                          const dated = moment(activeStartDate);
                          const month = dated.format("M");
                          const year = dated.format("YYYY");
                          console.log("month", month);
                          getMonthAvailableDates(month, year);
                        }}
                        minDate={new Date()}
                        onChange={onCalendarDateChange}
                        value={calendarDate}
                        locale="en-GB"
                      />
                    </div>
                  </form>
                </div>
                {(slots || []).length > 0 ? (
                  <>
                    <div className="col-sm-6 col-lg-6 col-md-6">
                      <input
                        type="text"
                        className="form-control rs-select-date-input"
                        placeholder="Select Time"
                        disabled="disabled"
                      />
                      <div className="col-12 px-0">
                        <div className="row main_time_div rs-timeslot-container">
                          {(slots || []).map((item, index) => {
                            if (item.status === 'NA') {
                              return null;
                            } else {
                              return (
                                <div
                                  key={index}
                                  className={`col-5 main_time rs-timeslot ${
                                    selectedSlot == item.slot ? "time_active" : ""
                                  }`}
                                  onClick={() => onSelectTimeSlot(item.slot)}
                                >
                                  {item.slot}
                                </div>
                              );
                            }
                          })}
                        </div>
                      </div>

                      <div className="col-12">
                        {selectedSlot ? (
                          <button
                            type="button"
                            className="se-btn se-btn--primary"
                            id="cnfrm_btn"
                            onClick={onConfirm}
                          >
                            {`Confirm ${selectedSlot}`}
                          </button>
                        ) : null}
                      </div>
                    </div>
                  </>
                ) : (
                  <div className="col-sm-6 col-lg-6 col-md-6">
                    <Loader isShowLoader={isLoading} />
                    <input
                      type="text"
                      className="form-control rs-select-date-input"
                      placeholder="Select Time"
                      disabled="disabled"
                    />
                    <div className="col-12 px-0">
                      <div className="row main_time_div">
                        <p className="text-left">No Slot Available.</p>
                      </div>
                    </div>
                  </div>
                )}
              </div>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default connect(null, {
  getAvailableTimeSlots,
  rescheduleEvent,
  getAvailableDates,
})(UpcomingRescheduleModal);
